/**
 * Il hook della cronologia (BACKGAMMON-UX rev.2, cantiere qgammon-orcb-30): mette insieme `match:history` (dal feed del coach) e gli eventi che
 * board-ui tiene per se' (`lastMove` = `match:moveApplied`, `lastRoll` = `match:dice`) nel riduttore puro di `cronologia.ts`.
 *
 * ⛔ Lo usa il PROVIDER (`ActiveMatchContext`, dentro `useComandoCoachVero`) SOLO nel ramo del confronto LETTERALE del flag del coach: in
 * produzione questo modulo non entra nella build. Sta nel provider e non nella rotta (D5 della revisione di #957): chi esce dal tavolo e rientra
 * senza una nuova join ritrova i turni.
 *
 * ⚠️ `lastMove` e `lastRoll` sono l'ULTIMO evento: se due arrivano nello stesso render il primo non si vede. Il riduttore non lo indovina: il ply
 * saltato diventa un `TurnoMancante` (la scheda scrive il motivo), e la prossima `match:history` (a ogni join) lo rimette.
 */
import { useEffect, useReducer } from 'react';
import type { MatchHistoryPayload } from '@qlashgeminiz/qgammon-types';

import { CRONOLOGIA_VUOTA, riduciCronologia, type DadiTirati, type MossaApplicata, type StatoCronologia } from '@/lib/qgammon/cronologia';

export function useCronologiaPartita(args: {
  storia: MatchHistoryPayload | null;
  lastMove: MossaApplicata | null;
  lastRoll: DadiTirati | null;
  matchId: string | null;
  gameNumber: number;
}): StatoCronologia {
  const [s, invia] = useReducer(riduciCronologia, CRONOLOGIA_VUOTA);
  const { storia, lastMove, lastRoll, matchId, gameNumber } = args;
  useEffect(() => {
    if (matchId !== null) invia({ tipo: 'partita', matchId, gameNumber });
  }, [matchId, gameNumber]);
  useEffect(() => {
    if (storia) invia({ tipo: 'storia', payload: storia });
  }, [storia]);
  useEffect(() => {
    if (lastRoll) invia({ tipo: 'dadi', payload: lastRoll, gameNumber });
  }, [lastRoll]);
  useEffect(() => {
    if (lastMove) invia({ tipo: 'mossa', payload: lastMove, gameNumber });
  }, [lastMove]);
  return s;
}
